var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShownFindingHint)?_c('div',{staticClass:"finding-hint-background"},[_c('div',{staticClass:"finding-hint"},[_c('h3',[_vm._v("Finding Hint ")]),_vm._l((_vm.list),function(n){return _c('h4',{key:n},[_vm._v(_vm._s(n))])})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }